import { FormGroup, FormControl } from '@angular/forms';

export function emailValidator(control: FormControl): { [key: string]: any } {
  const emailRegexp = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
  if (control.value && !emailRegexp.test(control.value)) {
    return { invalidEmail: true };
  }
}

export function userNameValidator(control: FormControl): { [key: string]: any } {
  const userNameRegexp = /^[A-Za-z0-9]+(?:[_-][A-Za-z0-9]+)*$/;
  if (control.value && !userNameRegexp.test(control.value)) {
    return { invalidUserName: true };
  }
}

export function passwordValidator(control: FormControl): { [key: string]: any } {
  const passwordRegexp =
    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&])([a-zA-Z0-9@$!%*#?&]{6,})$/;
  if (control.value && !passwordRegexp.test(control.value)) {
    return { invalidPassword: true };
  }
}

export function matchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
  return (group: FormGroup) => {
    const password = group.controls[passwordKey];
    const passwordConfirmation = group.controls[passwordConfirmationKey];
    if (password.value !== passwordConfirmation.value) {
      return passwordConfirmation.setErrors({ mismatchedPasswords: true });
    }
  };
}
